import { getDisplayDate } from '@billy/design-system'

import { LocaleIdentifier } from '../../../../../../../../../types/localeIdentifier'

interface GetSalesReportDateRangeLabelProps {
  startDate: string | undefined
  endDate: string | undefined
  locale: LocaleIdentifier
  firstFiscalYearStart: string | undefined
}

export const getSalesReportDateRangeLabel = ({
  startDate,
  endDate,
  locale,
  firstFiscalYearStart,
}: GetSalesReportDateRangeLabelProps): string => {
  const getFormattedDate = (date?: string) => date && getDisplayDate(new Date(date), locale)

  const salesReportStart = getFormattedDate(startDate) || getFormattedDate(firstFiscalYearStart)
  const salesReportEnd = getFormattedDate(endDate) || getDisplayDate(new Date(), locale)

  if (salesReportStart && salesReportEnd) {
    return `${salesReportStart} - ${salesReportEnd}`
  }

  return ''
}
